// import '@babel/polyfill';
// import "core-js/stable";
// import "regenerator-runtime/runtime";
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './routes';
import Vuetify from 'vuetify';
import VueRouter from 'vue-router';
import moment from 'moment';
import 'moment-timezone';
import VeeValidate from 'vee-validate'
import store from './store'
import axios from 'axios';

// import 'vue-material-design-icons/styles.css';

import "leaflet/dist/leaflet.css";
// import L from "leaflet";


import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

require('./assets/css/materialize_fonts.css');
require('./assets/css/materialize_icon_fonts.css');
require('./css/style.css');
//require('./assets/js/imagemapster.js');

//global variable
Vue.prototype.$headers = {
              'app-type': 'yatri-web',
              'api-key' : process.env.VUE_APP_API_KEY,
              "device-type" : `web`
            };

Vue.config.productionTip = false


// Vue.use(axios)
window.axios = axios;

window.VeeValidate=VeeValidate;
Vue.use(VeeValidate)
Vue.use(Vuetify, {
  theme:{
    primary: "#4c97e5",
    abcd:'#ff0000',
    secondary: "#fff",
    accent: "#383859",
    error: "#f44336",
    warning: "#ff9800",
    info: "#339999",
    success: "#4caf50",
    blend: "#ecf1f4",
    icon_color: "#bbbbc6"
  }

});

router.beforeEach(

  (to, from, next) => {
     if(to.path !== "/login" && localStorage.getItem("access_token") == null){
      store.dispatch('storeRedirectUrl',to.path);
    }
    if(to.matched.some(record => record.name == 'login')) {
      if(!localStorage.getItem('access_token')) {
        let user = JSON.parse(localStorage.getItem('auth_user'));
        if(user != null)
        {
          next({
              path: '/announcements',
          })
        }
        else {
        next();
      }
      } else {
        next();
      }
    } else if(to.matched.some(record => record.meta.forGuests)){
      next();
    } else if(to.matched.some(record => record.meta.forUsers)) {
        if(localStorage.getItem('access_token') === null) {
          next({
            name: 'login',
          })
        } else {
          if(!store.getters.get_access_token) {
            store.dispatch('storeAccessToken', localStorage.getItem('access_token'));
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.get_access_token;

            store.dispatch('storePermissions', localStorage.getItem('permissions'));
            store.dispatch('storeUser', JSON.parse(localStorage.getItem('auth_user')))
          }
            let permissions = store.getters.get_permissions;

            if(permissions.indexOf(to.meta.permission) == -1) {
                localStorage.removeItem('access_token')
                localStorage.removeItem('expiration')
                localStorage.removeItem('permissions')
                localStorage.removeItem('auth_user')
                store.dispatch('removeAccessToken')

                router.push({ name: 'login', query: { error: 'Session Expired' } })
            }
          next();
        }
      } else next();

  }

);

window.axios.interceptors.response.use(null, function(error) {
  switch(error.response.status) {
      case 401:
          localStorage.removeItem('access_token');
          localStorage.removeItem('expiration');
          localStorage.removeItem('permissions')
          localStorage.removeItem('auth_user');
          store.dispatch("removeAccessToken");
          store.dispatch("removePermissions");
          // this.$router.push({name: "login"});
          router.push({ name: 'login', query: {error: 'Session Expired'}});
          break;
      case 403:
          localStorage.removeItem('access_token')
          localStorage.removeItem('expiration')
          localStorage.removeItem('permissions')
          localStorage.removeItem('auth_user')
          store.dispatch("removeAccessToken");
          store.dispatch("removePermissions");
          router.push({ name: 'login', query: {error: 'Session Expired'}});
          break;
      case 404:
        //
          break;
      case 429:
        //
          break;
      default:
          break;
    }
  return Promise.reject(error);
});


Vue.mixin({
    filters: {
        appDateTimeFormat(val) {
            return moment(val).format('lll')
        },
        appTimeFormat(val) {
            return moment(val).format('LTS')
        },
        appDateFormat(val) {
            return moment(val).format('Do MMM YYYY')
        },
        capitalize(val) {
            return val[0].toUpperCase() + val.slice(1)
        }
    },
  methods: {
    startLoading() {
      store.dispatch('startLoader');
    },
    stopLoading() {
      store.dispatch('stopLoader');
    },
    moment_timezone(date_time = new Date()) {
      return moment(date_time).tz('Asia/Kolkata');
    },
    storage_path() {
      return `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_STORAGE_PATH}/`;
    },
    checkPermission(permission) {
      return store.getters.get_permissions.indexOf(permission) > -1;
    },
    download(data,file_name)
    {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.href =  url;
      link.setAttribute('download', file_name + Date.now() + '.' + 'csv');
      document.body.appendChild(link);
      link.click();
    },
    createFileLink(path) {
        return this.storage_path()+path;
    }
  }
});

Vue.use(VueRouter)

Vue.prototype.moment = moment

// Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

